import React from 'react';
import { ExternalLink, Video } from 'lucide-react';
import CallStage from './CallStage';
import PreJoin from './PreJoin';
import { fmtClockTime, fmtCountdown, useNow } from './time';

const Gate = ({ ctx, now, tz }) => {
  if (ctx.state === 'early') return <p className="vr-muted" data-testid="room-gate-early">The room opens 15 minutes before the start ({fmtClockTime(ctx.opens_at, tz)}). <span className="vr-count" data-testid="room-countdown">{fmtCountdown(ctx.opens_at, now)}</span></p>;
  if (ctx.state === 'closed') return <p className="vr-muted" data-testid="room-gate-closed">This room has closed. You can still finish your scorecard.</p>;
  if (ctx.state === 'cancelled') return <p className="vr-muted" data-testid="room-gate-cancelled">This interview was cancelled.</p>;
  if (ctx.state === 'not_booked') return <p className="vr-muted" data-testid="room-gate-unbooked">No time is booked yet.</p>;
  return null;
};

// Left column of the staff room: pre-join check, the live call, or the external-link notice.
export default function StaffStage({ ctx, dc, media, joining, onJoin, listen, setListen, tz }) {
  const now = useNow();
  if (ctx.venue !== 'chire') {
    return (
      <div className="vr-card" data-testid="room-external">
        <h2>This interview uses an external meeting link</h2>
        <p className="vr-muted">The live copilot needs the CHIRE video room. You can still use the brief and fill in your scorecard here.</p>
        {ctx.booking.meeting_link && <a className="iv-btn iv-btn-cta" style={{ marginTop: '0.8rem' }} href={ctx.booking.meeting_link} target="_blank" rel="noreferrer" data-testid="room-external-link"><ExternalLink size={16} /> Open meeting link</a>}
      </div>
    );
  }
  if (dc.state === 'joined') return <CallStage dc={dc} onLeave={dc.leave} emptyText="Waiting for the candidate to join…" />;
  const canJoin = ctx.state === 'open' && ctx.video_configured;
  return (
    <div className="vr-card vr-prejoin" data-testid="room-prejoin-card">
      <h2>{dc.state === 'left' ? 'You left the call' : 'Ready to join?'}</h2>
      <Gate ctx={ctx} now={now} tz={tz} />
      {dc.error && <div className="iv-note is-bad" style={{ margin: '0.6rem 0' }} data-testid="room-call-error">{dc.error}</div>}
      {(ctx.state === 'open' || ctx.state === 'early') && <PreJoin media={media} />}
      {ctx.role === 'interviewer' && (
        <label className="vr-switch" data-testid="room-listen-toggle">
          <input type="checkbox" checked={listen} onChange={() => setListen((v) => !v)} data-testid="room-listen-checkbox" />
          <span>Copilot listens: transcribes your microphone, and the candidate's audio if they agreed, to suggest follow-ups.</span>
        </label>
      )}
      <div className="iv-row-end">
        <button type="button" className="iv-btn iv-btn-cta" disabled={!canJoin || joining} onClick={onJoin} data-testid="room-join-btn">
          <Video size={16} /> {joining ? 'Joining…' : dc.state === 'left' ? 'Rejoin' : 'Join interview'}
        </button>
      </div>
    </div>
  );
}
